<script lang="ts">
	import { PUBLIC_SITE_NAME } from '$env/static/public';
	import { twMerge } from 'tailwind-merge';
	import logoImg from '@lib/images/logo/brand.webp?enhanced';

	let className = '',
		isPriority = false;

	export { className as class, isPriority };
</script>

<a
	href="/"
	aria-label="Logo"
	class="aspect-[128/35] {twMerge('block w-full max-w-36 pre-md:max-w-40', className)}"
>
	<slot name="logo-img">
		<enhanced:img
			loading={isPriority ? 'eager' : 'lazy'}
			fetchpriority={isPriority ? 'high' : 'auto'}
			class="w-full"
			src={logoImg}
			alt={PUBLIC_SITE_NAME}
		/>
	</slot>
</a>
